import { render, staticRenderFns } from "./prize-money.vue?vue&type=template&id=41958869&scoped=true&"
import script from "./prize-money.vue?vue&type=script&lang=js&"
export * from "./prize-money.vue?vue&type=script&lang=js&"
import style0 from "./prize-money.vue?vue&type=style&index=0&id=41958869&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41958869",
  null
  
)

export default component.exports